import { USER_INFO_NAME } from "./config";
export default () => {
  return JSON.parse(localStorage.getItem(USER_INFO_NAME) || "");
};
